import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { setMessage } from '../message';
import AuthService from '../../services/authServices';

const user = JSON.parse(localStorage.getItem('user') ?? '{}');
const token = localStorage.getItem('token');
const permission = JSON.parse(localStorage.getItem('permission') ?? '[]');

export const register = createAsyncThunk('auth/register', async ({ username, email, password }, thunkAPI) => {
  try {
    const response = await AuthService.register(username, email, password);
    return response.data;
  } catch (error) {
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    thunkAPI.dispatch(setMessage({ message: message, type: 'error' }));
    return thunkAPI.rejectWithValue();
  }
});

export const login = createAsyncThunk('auth/login', async ({ email, password, remember = false }, thunkAPI) => {
  try {
    const data = await AuthService.login(email, password, remember);
    return { user: data };
  } catch (error) {
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    thunkAPI.dispatch(setMessage({ message: message, type: 'error' }));
    return thunkAPI.rejectWithValue();
  }
});

export const setFcmToken = createAsyncThunk('auth/setFcmToken', async (data, thunkAPI) => {
  try {
    await AuthService.setFcmToken(data);
  } catch (error) {
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    thunkAPI.dispatch(setMessage({ message: message, type: 'error' }));
    return thunkAPI.rejectWithValue();
  }
});

export const logout = createAsyncThunk('auth/logout', async (_, thunkAPI) => {
  try {
    await AuthService.logout();
  } catch (error) {
    thunkAPI.dispatch(clearAuth());
  }
});

export const clearAuth = createAsyncThunk('auth/clearAuth', async () => {
  AuthService.clearAuth();
});

const initialState = token
  ? { isLoggedIn: true, isLoading: false, token, user, permission }
  : { isLoggedIn: false, isLoading: false, token: null, user: null, permission: null };

const authSlice = createSlice({
  name: 'auth',
  initialState,
  extraReducers: (builder) => {
    builder.addCase(register.pending, (state) => {
      state.isLoading = true;
    }),
      builder.addCase(register.fulfilled, (state) => {
        state.isLoading = false;
        state.isLoggedIn = false;
      }),
      builder.addCase(register.rejected, (state) => {
        state.isLoading = false;
        state.isLoggedIn = false;
      }),
      builder.addCase(login.pending, (state) => {
        state.isLoading = true;
      }),
      builder.addCase(login.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isLoggedIn = true;
        state.token = action.payload.token;
        state.user = action.payload.user;
        state.permission = action.payload.permission;
      }),
      builder.addCase(login.rejected, (state) => {
        state.isLoading = false;
        state.isLoggedIn = false;
        state.token = null;
        state.user = null;
        state.permission = null;
      }),
      builder.addCase(setFcmToken.pending, (state) => {
        state.isLoading = true;
      }),
      builder.addCase(setFcmToken.fulfilled, (state) => {
        state.isLoading = false;
      }),
      builder.addCase(setFcmToken.rejected, (state) => {
        state.isLoading = false;
      }),
      builder.addCase(logout.fulfilled, (state) => {
        state.isLoggedIn = false;
        state.token = null;
        state.user = null;
        state.permission = null;
      }),
      builder.addCase(clearAuth.fulfilled, (state) => {
        state.isLoggedIn = false;
        state.token = null;
        state.user = null;
        state.permission = null;
      });
  }
});

const { reducer } = authSlice;
export default reducer;
